export default __webpack_public_path__ + "static/mcv-guide-mobile-90d8474fed372260e492e1b83746c937.png";